import {setImageElementAlt} from '../../../../../shared/scripts/ui_utils/DomUtils'
import {LobbyImage} from '@colonist/types'
import {UserState} from '../../../../../../shared/UserState'
import {getLobbyImagePath} from '../../../../../shared/scripts/ui_utils/Utils'

export class UIMHeaderProfileController {
    private readonly playerMembershipIcon: HTMLImageElement

    constructor() {
        this.playerMembershipIcon = document.getElementById('header-profile-membership-icon') as HTMLImageElement
    }

    updateMembershipIcon(userState: UserState) {
        const currentMembership = userState.items.getCurrentMembership()
        if(currentMembership != undefined) {
            UIMHeaderProfileController.updateIcon(currentMembership.image, this.playerMembershipIcon)
            this.playerMembershipIcon.style.display = 'block'
            if(currentMembership.pending) this.playerMembershipIcon.style.filter = 'grayscale(1)'
        }
    }

    static updateIcon(icon: LobbyImage, element: HTMLImageElement) {
        const path = getLobbyImagePath(icon)
        element.src = path
        setImageElementAlt(element, icon)
    }
}
